import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../assets/images/Code Infoway.png";
import { Link } from "react-router-dom";

// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faBarsStaggered,
//   faRightFromBracket,
//   faUser,
//   faBell,
// } from "@fortawesome/free-solid-svg-icons";

export const NavbarRow = () => {
  return (
    <React.Fragment>
      <Navbar expand="lg">
        <Container>
          <Navbar.Brand href="#">
            <img src={Logo} alt="Code Infoway Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-0 ms-auto">
              <Nav.Item>
                <Nav.Link as={Link} to="/">
                  Home
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/about-us">
                  About Us
                </Nav.Link>
              </Nav.Item>
              <NavDropdown title="Services" id="services-dropdown">
                <NavDropdown.Item as={Link} to="/react-native">
                  React Native
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ios">
                  IOS
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/android">
                  Android
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ipad-tablet">
                  iPad & Tablet
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/flutter">
                  Flutter
                </NavDropdown.Item>
              </NavDropdown>
              <Nav.Item>
                <Nav.Link as={Link} to="/portfolio">
                  Portfolio
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link as={Link} to="/blog">
                  Blogs
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/contact-us"
                  className="btn btn-primary"
                >
                  Contact Us
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </React.Fragment>
  );
};
